/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestStepBaseAsJSONParser = 
/* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['weight', codecNumber],
    ['hidden', codecBoolean],
]);
export class AutoTestStepBaseAsJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestStepBaseAsJSONParser.decode(input).map(res => new AutoTestStepBaseAsJSON(res));
    }
    static unsafeDecode(input) {
        return AutoTestStepBaseAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestStepBaseAsJSONParser.encode(data);
    }
    static schema() {
        return AutoTestStepBaseAsJSONParser.schema();
    }
}
